import React, { useEffect, useState } from "react";
import Uppy from "@uppy/core";
import AwsS3Multipart from "@uppy/aws-s3-multipart";
import { DashboardModal } from "@uppy/react";
import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";
import "@uppy/webcam/dist/style.min.css";
import { Constants } from "../Constants";

const FileAwsUpload = (props) => {
  const [isOpen, setOpen] = useState(false);

  // Function to rename files before upload
  const renameFile = (file) => {
    // Replace '_' with '*' in the file name
    const newName = file.name.replace(/_/g, "*");
    uppy.setFileMeta(file.id, { name: newName });
  };

  // Initialize Uppy instance with restrictions and plugins
  const uppy = new Uppy({
    restrictions: {
      maxNumberOfFiles: props?.maxFiles,
      allowedFileTypes: props?.fileType,
    },
  });

  // Effect to set up Uppy plugins and event listeners when the modal is open
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isOpen) {
      uppy
        .use(AwsS3Multipart, {
          companionUrl: process.env.REACT_APP_BASE_SOCKET_URL,
          // Add the `onBeforeUpload` option to handle file renaming before upload
          onBeforeUpload: (files) => {
            files.forEach(renameFile);
          },
        })
        // Event listener for upload completion
        .on("complete", (result) => {
          // Call handleFile and handleMediaType functions with the result
          props?.handleFile(result?.successful?.map((file) => file.uploadURL));
          if (props?.handleMediaType)
            props?.handleMediaType(result?.successful?.[0]?.extension);
          // Close the modal
          setOpen(false);
        });

      // Clean up function to close Uppy when component unmounts
      return () => {
        uppy.close();
      };
    }
  }, [isOpen]);

  return (
    <div className="body d-flex py-3 design-popup">
      <i className="fa fa-upload upload-ic"></i>
      {/* DashboardModal component for Uppy file upload */}
      <DashboardModal
        uppy={uppy}
        open={isOpen}
        onRequestClose={() => {
          setOpen(false);
        }}
      />
      {/* Button to open the modal */}
      <div className="flex-p" onClick={() => setOpen(true)}>
        <span className="img-upload-label">{`${props.label}`}</span>
        <span className="font-12">{` (${Constants.width}: ${props?.width}px, ${Constants.height}: ${props?.height}px)`}</span>
        <span className="font-12">{`${
          props?.fileType
            ? ` (${Constants.accepts} ${(props?.fileType).join(", ")}`
            : ""
        })`}</span>
      </div>
      {/* Display error message if any */}
      {(props.errors || props.touched) && (
        <p className="error-msg mt-4">{props.errors}</p>
      )}
    </div>
  );
};

export default FileAwsUpload;
